var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowToBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / arrow-to-bottom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M4.25002 11.8382H12.25V13.1715H4.25002V11.8382ZM7.58335 2.50488V8.22888L4.72135 5.36688L3.77869 6.30955L8.25002 10.7809L12.7214 6.30955L11.7787 5.36688L8.91669 8.22888V2.50488H7.58335Z",
    fill: "#292829"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToBottom);
export default __webpack_public_path__ + "static/media/arrow-to-bottom.cacd65a0a7f6c8bd04dfdc6450f65d0f.svg";
export { ForwardRef as ReactComponent };